import { useEffect, useState } from 'react';

declare global {
  interface Window {
    deferredInstallPrompt: Event | null;
  }
}

window.deferredInstallPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredInstallPrompt = e;
});

export const useInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<Event | null>(null);
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsSupported(true);
      window.deferredInstallPrompt = e;
    };

    // Listen for the event
    window.addEventListener('beforeinstallprompt', handler);

    // Check if it already fired
    if (window.deferredInstallPrompt) {
      setDeferredPrompt(window.deferredInstallPrompt);
      setIsSupported(true);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const promptInstall = async () => {
    if (deferredPrompt) {
      // @ts-ignore
      await deferredPrompt.prompt();
      // @ts-ignore
      const result = await deferredPrompt.userChoice;
      setDeferredPrompt(null);
      return result.outcome;
    }
    return null;
  };

  return { isSupported, promptInstall };
};
